import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import ButtonComponent from './ButtonComponent'

import 'cropperjs/dist/cropper.css'
import PreloaderButton from './PreloaderButton'

interface IUploadMediaButtonData{
  onFileUpload?: (image: string, file: File | undefined) => void // Not used for images and video
  onImageUpload?: (image: string, file: File | undefined) => void
  onVideoUpload?: (video: string, file: File | undefined) => void
  allowImageUpload?: boolean
  allowVideoUpload?: boolean
  allowAdditionalTypes?: string
  disabled?: boolean
}

export const UploadMediaButton: React.FC <IUploadMediaButtonData> = (props) => {
  const { t } = useTranslation()

  const [fileUrl, setFileUrl] = useState<string|undefined>()
  const [file, setFile] = useState<File | undefined>()
  const [allowUpload, setAllowUpload] = useState<string[]>(['image/*', 'video/*'])

  useEffect(() => {
    if (!props.allowImageUpload) setAllowUpload(allowUpload.filter(a => a !== 'image/*'))
    if (!props.allowVideoUpload) setAllowUpload(allowUpload.filter(a => a !== 'video/*'))
    if (props.allowAdditionalTypes) setAllowUpload([...allowUpload, props.allowAdditionalTypes])
  }, [props])

  useEffect(() => {
    if (file && fileUrl) {
      file.type.includes('image') && props.onImageUpload && props.onImageUpload(fileUrl, file)
      file.type.includes('video') && props.onVideoUpload && props.onVideoUpload(fileUrl, file)
      props.onFileUpload && props.onFileUpload(fileUrl, file) // Control what Files can be sent here via the allowAditionalTypes property
    }
  }, [fileUrl, file])

  const onChange = (e: any) => {
    e.preventDefault()
    let files
    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }
    setFile(files[0])

    const reader = new FileReader()
    reader.onload = () => {
      setFileUrl(reader.result as any)
    }
    reader.readAsDataURL(files[0])
  }

  const hiddenFileInput = React.useRef<HTMLInputElement>(null)
  const handleClick = () => {
    hiddenFileInput?.current?.click()
  }

  return (
    <>
      <PreloaderButton
        color='primary'
        text={t('commonImage:chooseNewFile')}
        onClick={handleClick}
        loading={props.disabled}
        position='left'
        disableButton={props.disabled}
      />
      <input
        type='file'
        ref={hiddenFileInput}
        onInput={onChange}
        style={{ display: 'none' }}
        accept={allowUpload.toString()}
      />
    </>
  )
}
export default UploadMediaButton
